/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import Timeago from "react-timeago";
import { CollectionName } from "../../Atoms/CollectionName";
import { LoadmoreButton } from "../../Atoms/Loadmore";
import { formatter, generateNavigateSlug, getTextColor, navigateTo } from "../../../utils/utils";
import "./magazine-cards.m.css";
import { StateProvider } from "../../SharedContext";
import { MagazineCoverImageCard } from "../../Atoms/MagazineCoverImage";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash.get";

const MagazineHeaderCard = ({ collection = {}, config = {} }) => {
  const { "created-at": createdAt, summary } = collection;
  const { theme = "", text, customUrlPath = "" } = config;
  const textColor = getTextColor(theme);
  const dispatch = useDispatch();
  const qtConfig = useSelector(state => get(state, ["qt", "config"], {}));
  const url = generateNavigateSlug(collection, qtConfig, customUrlPath);

  return (
    <div
      className="full-width-with-padding arrow-component"
      style={{ backgroundColor: theme }}
      data-test-id="magazine-header-card"
    >
      <div className="arr-magazine-card" styleName="magazine-header intro-button">
        <MagazineCoverImageCard collection={collection} config={config} />
        <div styleName="content">
          <div styleName={`time ${textColor}`}>
            <Timeago date={createdAt} formatter={formatter} />
          </div>
          <CollectionName collection={collection} />
          <div styleName={`summary ${textColor}`}>{text || summary}</div>
          <LoadmoreButton
            collection={collection}
            template="customUrlPath"
            config={config}
            navigate={() => navigateTo(dispatch, url)}
            qtConfig={qtConfig}
          />
        </div>
      </div>
    </div>
  );
};

MagazineHeaderCard.propTypes = {
  collection: PropTypes.shape({
    "created-at": PropTypes.number,
    summary: PropTypes.string,
    items: PropTypes.array
  }),
  config: PropTypes.shape({ theme: PropTypes.string, footerButton: PropTypes.string })
};

export default StateProvider(MagazineHeaderCard);
